import React from 'react';
import { ArrowRight, Check } from 'lucide-react';
import { vivoCreators } from '../data/mock';
import { trackCtaClick } from '../utils/analytics';

const VivoCreators = () => {
  const handleCreatorPageOpen = () => {
    const url = '/vivo-creator';
    trackCtaClick({ cta: 'vivo_creator_page', location: 'vivo_creators', url });
    window.location.assign(url);
  };

  const handlePartnershipContact = () => {
    const subject = 'Parcerias / Creator';
    const message = encodeURIComponent(`Olá! Gostaria de conversar sobre ${subject}.`);
    const whatsappUrl = `https://wa.me/5511984845464?text=${message}`;
    trackCtaClick({ cta: 'whatsapp', location: 'contact', url: whatsappUrl });
    window.open(whatsappUrl, '_blank');
  };

  return (
    <section id="vivo-creators" className="section-padding">
      <div className="container-custom">
        <div className="vivo-creators-content">
          <h2 className="section-title">{vivoCreators.title}</h2>
          <p className="vivo-creators-subtitle">{vivoCreators.subtitle}</p>

          <div className="vivo-creators-description">
            {vivoCreators.description.split('\n\n').map((paragraph, index) => (
              <p key={index} className="vivo-creators-paragraph">{paragraph}</p>
            ))}
          </div>

          <div className="vivo-creators-highlights">
            {vivoCreators.highlights.map((highlight, index) => (
              <div key={index} className="highlight-item">
                <Check size={20} className="highlight-icon" />
                <span>{highlight}</span>
              </div>
            ))}
          </div>

          <div className="vivo-creators-cta">
            <button onClick={handleCreatorPageOpen} className="btn-primary">
              Conheça minha página de Vivo Creator
              <ArrowRight size={20} />
            </button>
            <button onClick={handlePartnershipContact} className="btn-secondary">
              Falar sobre parcerias
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VivoCreators;
